/* eslint-disable react/jsx-no-useless-fragment */
// TODO: use new compoent modal
// TODO: MODAL PROVIDER LOCAL
import { ModalProps } from "./types";
import { useModal, useUpdateModal } from "utilities/ModalProvider";
import ChildrenRender from "utilities/ChildrenRender";
import ModalLayout from "components/ModalLayout";
import Portal from "./Portal";
import React from "react";

const Modal = (props: ModalProps) => {
  const { id, children, ...modalLayoutProps } = props;

  const { modalId, modalProps } = useModal();
  const { closeModal } = useUpdateModal();

  return (
    <>
      {id === modalId && (
        <Portal>
          <ModalLayout closeModal={closeModal!} {...modalLayoutProps}>
            <ChildrenRender propsToChild={modalProps}>
              {children}
            </ChildrenRender>
          </ModalLayout>
        </Portal>
      )}
    </>
  );
};

export default Modal;
